import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'providerPipe'
})
export class ProviderPipePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return value === 'PRACTICE' ? 'Dental Practice' : value === 'PROVIDER' ? 'Individual Provider' : value;
  }
}
